import constant from '../../constant'

const initialState = { 
  articles: {
    cardContents: [],
    list: [],
    bannerList: []
  },
  backNews: {
    medias: [],
    mediaType: ''
  },
  interestRecommend: []
};

export function recommend (state = initialState, action) {
  switch (action.type) {
    case constant.RECOMMEND.GET_ARTICLES_SUCCESS:
      return Object.assign({}, state, {
        articles: action.articles,
        bannerList: action.bannerList
      })
    case constant.RECOMMEND.GET_BACK_NEWS_SUCCESS:
      return Object.assign({}, state, {
        backNews: action.backNews
      })
    case constant.RECOMMEND.LOAD_MORE_ARTICLES:
      return {
        ...state,
        articles: {
          ...action.articles(state.articles)
        }
      }
    case constant.RECOMMEND.GET_INTEREST_RECOMMEND_SUCCESS:
      return Object.assign({}, state, {
        interestRecommend: action.interestRecommend,
      })      
    default:
      return state
  }

}